import { render, staticRenderFns } from "./DismissedPractitionerComplaints.vue?vue&type=template&id=b0b6128a&scoped=true&"
import script from "./DismissedPractitionerComplaints.vue?vue&type=script&lang=js&"
export * from "./DismissedPractitionerComplaints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b6128a",
  null
  
)

export default component.exports